import firebase from 'firebase';

import {
  userDataSuccess,
  userDataRequest,
  userDataFailure,
  userDataClear,
} from '.';
import CompaniesHelper from '../companies/action';
import CastingsHelper from '../castings/action';
import UsersHelper from '../users/action';
import CategorisHelper from '../categories/action';
import StatisticHelper from '../statistic/action';
import { UserService } from '../../services/requests';

const UserActions = {
  authorization: (logOut) => async (dispatch) => {
    dispatch(userDataRequest());
    await firebase.auth().onAuthStateChanged(async (user) => {
      if (user) {
        try {
          const res = await UserService.getDetailedUserData();
          if (res && res.role === 'admin') {
            dispatch(userDataSuccess(res));

            dispatch(CompaniesHelper.getAllCompanies());
            dispatch(CompaniesHelper.getModeratedCompanies());
            dispatch(CompaniesHelper.getDeclinedCompanies());
            dispatch(CastingsHelper.getCastingsInModerated());
            dispatch(CastingsHelper.getArchivedCastings());
            dispatch(CastingsHelper.getAllCastings());
            dispatch(CastingsHelper.getDeclinedCastings());
            dispatch(CategorisHelper.getAllCastings());
            dispatch(UsersHelper.getAllUsers());
            dispatch(StatisticHelper.getAllStatistic());
          } else if (res && res.role !== 'admin') {
            logOut();
          }
        } catch (err) {
          console.log(err);
        }
      } else {
        dispatch(userDataRequest());
        try {
          dispatch(userDataClear());
        } catch (e) {
          dispatch(userDataFailure(e));
        }
      }
    });
  },

  logOut: (logOutFunction) => async (dispatch) => {
    try {
      await logOutFunction();
      dispatch(userDataClear());
    } catch {
      /**
       * DO NOTHING
       */
    }
  },
};

export default UserActions;
